import {PlexiDesigner} from '@jacob-van-dam-ict/plexiglas-designer/dist/plexi-designer';

new PlexiDesigner({
    selectedShapeInputSelector: '#product_1_designer_selected_shape',
    thumbnailInputSelector: '#product_1_designer_thumbnail',
    shapeButtonSvgClasses: [
        'w-full',
        'h-full',
    ],
    updateUrl: true,
    shapeButtonsContainer: '.plexidesigner-shapes-container',
    allowedShapes: plexi_designer_options.allowed_shapes,
    cloneSvgTo: [
        '#add-to-cart-modal .image-container',
        '#dialog-designer-content',
    ],
});